import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import { EnhancedPlan } from '@mm/state/interfaces/subscription';

export const getPriceBySeats = ({
  seatsNumber,
  isDowngrade,
  proRatedDueToday,
  currentSubscription,
  plan,
  futurePaymentCredits,
}: {
  seatsNumber: number;
  isDowngrade: boolean;
  proRatedDueToday: number;
  currentSubscription: SubscriptionModel;
  plan: EnhancedPlan;
  futurePaymentCredits?: number;
}) => {
  const {
    sendAllotmentAddOnPrice = 0,
    userSeatsAddOnPrice,
    smsNumberAddOnPrice,
  } = plan;

  const currentSendCreditsValue = currentSubscription
    ? currentSubscription.maxSendAllotment || 0
    : 0;
  const currentSendCreditsPrice = currentSubscription
    ? (currentSubscription.sendAllotmentLevel || 0) * sendAllotmentAddOnPrice
    : 0;

  const currentUserSeatsPrice = currentSubscription
    ? (userSeatsAddOnPrice || 0) * currentSubscription.extraUserSeats
    : 0;

  const userSeatsFromPlanAndSubscription =
    currentSubscription.extraUserSeats + plan.userSeats;
  const currentUserSeatsValue = currentSubscription
    ? userSeatsFromPlanAndSubscription
    : 0;

  const newUserSeatsValue =
    userSeatsFromPlanAndSubscription + seatsNumber === currentUserSeatsValue &&
    !isDowngrade
      ? currentUserSeatsValue
      : seatsNumber + plan.userSeats;

  const newUserSeatsPrice =
    userSeatsFromPlanAndSubscription + seatsNumber === currentUserSeatsValue &&
    !isDowngrade
      ? currentSubscription.extraUserSeats * userSeatsAddOnPrice
      : seatsNumber * userSeatsAddOnPrice;

  const currentMonthlyFee = currentSubscription.unitAmountInCents / 100;
  const newMonthlyFee =
    currentSubscription.unitAmountInCents / 100 +
    (currentUserSeatsPrice === newUserSeatsPrice
      ? 0
      : isDowngrade
      ? -(currentUserSeatsPrice - newUserSeatsPrice)
      : (seatsNumber - currentSubscription.extraUserSeats) *
        userSeatsAddOnPrice);

  const payNow = proRatedDueToday
    ? Math.abs(proRatedDueToday)
    : Math.abs(newUserSeatsPrice) > currentUserSeatsPrice
    ? newUserSeatsPrice
    : 0;
  const smsNumberCount = currentSubscription?.smsNumbers
    ? Object.values(currentSubscription.smsNumbers).filter(Boolean).length
    : 0;
  const currentSmsNumberPrice = smsNumberAddOnPrice
    ? smsNumberCount * smsNumberAddOnPrice
    : 0;
  const proRatedAmount = Math.abs(proRatedDueToday);

  return {
    planPrice: currentSubscription.basePrice,
    newSendCreditsValue: null,
    currentSendCreditsValue,
    currentMonthlyFee,
    currentSendCreditsPrice: null,
    currentUserSeatsValue,
    currentUserSeatsPrice,
    newUserSeatsPrice,
    newUserSeatsValue,
    newSendCreditsPrice: currentSendCreditsPrice,
    newMonthlyFee: Math.abs(newMonthlyFee),
    smsNumberCount,
    currentSmsNumberPrice: null,
    newSmsNumberPrice: currentSmsNumberPrice,
    newSmsNumberCount: null,
    payNow,
    proRatedAmount,
    proRatedAsCredit: futurePaymentCredits,
    showAddCoupon: false,
  };
};
